import React from 'react';

import { Table, Input, Button, Space, Tooltip } from 'antd';
import Highlighter from 'react-highlight-words';
import { SearchOutlined, EditOutlined, DeleteOutlined, MailOutlined } from '@ant-design/icons';

class TabelaFormandos extends React.Component {

  state = {
    searchedColumn: {}
  }

  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#d32f2f' : undefined }} />,
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : '',
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: text =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffcdd2', padding: 0, fontWeight: 'bold' }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };

  render() {
    const columns = [
      {
        title: 'Nome',
        key: 'nome',
        dataIndex: 'nome',
        sorter: (a, b) => a.nome.localeCompare(b.nome, 'pt-BR', { sensitivity: 'base' }),
        defaultSortOrder: 'ascend',
        ...this.getColumnSearchProps('nome'),
      },
      {
        title: 'E-mail',
        key: 'email',
        dataIndex: 'email',
        ...this.getColumnSearchProps('email'),
      },
      {
        title: 'Celular',
        key: 'celular',
        dataIndex: 'celular',
        ...this.getColumnSearchProps('celular'),
      },
      {
        title: 'CPF',
        key: 'documento',
        dataIndex: 'documento',
        ...this.getColumnSearchProps('documento'),
        render: (documento) => documento ? documento.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4') : '-'
      },
      {
        title: 'Data de Nascimento',
        key: 'dataNascimento',
        dataIndex: 'dataNascimento',
        ...this.getColumnSearchProps('dataNascimento'),
        render: (dataNascimento) => {
          if (!dataNascimento || dataNascimento === '') return '-';

          // Trata string
          if (typeof dataNascimento === 'string') {
            // Remove espaços extras
            dataNascimento = dataNascimento.trim();

            // Formato YYYY-MM-DD ou YYYY/MM/DD (ISO)
            if (dataNascimento.match(/^\d{4}[-\/]\d{2}[-\/]\d{2}$/)) {
              const partes = dataNascimento.split(/[-\/]/);
              const ano = partes[0];
              const mes = partes[1];
              const dia = partes[2];
              return `${dia.padStart(2, '0')}/${mes.padStart(2, '0')}/${ano}`;
            }

            // Formato DD-MM-YYYY ou DD/MM/YYYY (já no formato correto)
            if (dataNascimento.match(/^\d{2}[-\/]\d{2}[-\/]\d{4}$/)) {
              return dataNascimento.replace(/-/g, '/');
            }

            // Formato DD-MM-YY ou DD/MM/YY (ano com 2 dígitos)
            if (dataNascimento.match(/^\d{2}[-\/]\d{2}[-\/]\d{2}$/)) {
              const partes = dataNascimento.split(/[-\/]/);
              const dia = partes[0];
              const mes = partes[1];
              const ano = '20' + partes[2]; // Assume 20XX
              return `${dia}/${mes}/${ano}`;
            }
          }

          // Fallback: retorna como está
          return dataNascimento;
        }
      },
      {
        title: 'Curso',
        key: 'curso',
        dataIndex: 'curso',
        ...this.getColumnSearchProps('curso'),
      },
      {
        title: 'Ações',
        key: 'action',
        render: (record) => (
          <Space>
            <Tooltip title="Editar">
              <Button
                icon={<EditOutlined />}
                onClick={() => this.props.editarFormando(record)}
                style={{ color: '#d32f2f', borderColor: '#d32f2f', backgroundColor: '#fff' }}
              >
                Editar
              </Button>
            </Tooltip>
            {record.usuario ? (
              <Tooltip title="Reenviar acesso">
                <Button icon={<MailOutlined />} onClick={() => this.props.reenviarEmail(record)}>Reenviar</Button>
              </Tooltip>
            ) : null}
            {this.props.isAdmin ? (
              <Tooltip title="Excluir">
                <Button type="primary" danger icon={<DeleteOutlined />} onClick={() => this.props.excluirFormando(record.id)}>Excluir</Button>
              </Tooltip>
            ) : null}
          </Space>
        ),
      }
    ];
    return (
      <div className="table-responsive">
        <Table columns={columns} dataSource={this.props.data} rowKey={record => record.id} bordered />
      </div>
    );
  }
}

export default TabelaFormandos;
